export const volume = {
  inserted(el,binding){
    if(el.volume) el.volume=binding?.value
  },
  update(el,binding){
    if(el.volume) el.volume=binding?.value
  },
}